/** 图片 API 地址 */
// export const IMAGE_API_URL = 'http://localhost:5001';
// export const IMAGE_API_URL = 'https://test-front.supptech.net';
/** 图片 base url */
// export const IMAGE_BASE_URL = 'https://creator.nightcafe.studio';

export const IMAGE_BASE_URL = 'https://images.nightcafe.studio/';

/** 作品封面缺失时的兜底占位图 (后端 artworkImageUrl 为 null 时使用) */
export const ARTWORK_COVER_PLACEHOLDER =
  'https://prodsuppart-s3.suppart.app/artworkCover/a_high_quality_modern_and_minimalist_placeholder_image_for_work_deleted_or.png';
